import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemText,
  useMediaQuery,
  ListItemButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import CountdownTimer from './CountDownTimer';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from './Router';
import { getCurrentDate } from '../utils/format';
import { getRadientBG } from '../utils/display';

const Header = () => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const handleLogoClick = () => {
    setOpen(false);
    navigate(ROUTES.HOME);
  };

  const handleContactClick = () => {
    setOpen(false);
    navigate(ROUTES.CONTACT);
  };

  const handleCoursesClick = () => {
    setOpen(false);
    navigate(`courses/${getCurrentDate()}`);
  };

  const handleTipsClick = () => {
    setOpen(false);
    navigate(ROUTES.TIPS);
  };

  const handleHomeClick = () => {
    setOpen(false);
    navigate(ROUTES.HOME);
  };

  return (
    <AppBar position="sticky">
      <Box
        component="header"
        sx={{
          width: '100%',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          background: 'primary.dark',
          backdropFilter: 'blur(14px)',
        }}
      >
        <Box
          sx={{
            mx: 'auto',
            px: 2,
            height: 60,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              minWidth: 160,
              cursor: 'pointer',
            }}
            onClick={() => navigate('/')}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: '10px',
                background: 'rgba(16,185,129,0.12)',
                boxShadow: '0 0 0 1px rgba(52,211,153,0.25)',
                display: 'grid',
                placeItems: 'center',
              }}
            >
              <Box
                component="img"
                src="/expert_turf_icon.png"
                alt="Expert Turf"
                sx={{
                  width: 28,
                  height: 28,
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  lineHeight: 1.2,
                  color: '#f1f5f9',
                }}
              >
                ExpertTurf
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.7rem',
                  color: 'rgba(203,213,225,0.60)',
                  lineHeight: 1,
                }}
              >
                {isMobile ? 'Pronos & Stats' : 'Pronostics & statistiques'}
              </Typography>
            </Box>
          </Box>

          {!isMobile && <CountdownTimer />}

          <Box
            sx={{ display: 'flex', justifyContent: 'flex-end', minWidth: 160 }}
          >
            <IconButton color="inherit" onClick={() => setOpen(true)}>
              <MenuIcon />
            </IconButton>

            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
              <List
                sx={{ width: 250, background: getRadientBG(), height: '100%' }}
              >
                <ListItemButton onClick={handleHomeClick}>
                  <ListItemText
                    primary="Accueil"
                    slotProps={{
                      primary: {
                        sx: {
                          fontSize: 20,
                          fontWeight: 550,
                          color: 'white',
                        },
                      },
                    }}
                  />
                </ListItemButton>
                <ListItemButton onClick={handleCoursesClick}>
                  <ListItemText
                    primary="Courses"
                    slotProps={{
                      primary: {
                        sx: {
                          fontSize: 20,
                          fontWeight: 600,
                          color: 'white',
                        },
                      },
                    }}
                  />
                </ListItemButton>
                <ListItemButton onClick={handleTipsClick}>
                  <ListItemText
                    primary="Conseils & méthode"
                    slotProps={{
                      primary: {
                        sx: {
                          fontSize: 20,
                          fontWeight: 600,
                          color: 'white',
                        },
                      },
                    }}
                  />
                </ListItemButton>
                <ListItemButton onClick={handleContactClick}>
                  <ListItemText
                    primary="Contact"
                    slotProps={{
                      primary: {
                        sx: {
                          fontSize: 20,
                          fontWeight: 600,
                          color: 'white',
                        },
                      },
                    }}
                  />
                </ListItemButton>
              </List>
            </Drawer>
          </Box>
        </Box>
      </Box>
    </AppBar>
  );
};

export default Header;
